import axiosPost from "./axiosPost";

export const RNHAreaIns = async (credentials, data) => {
    const body = {
        service: "RNHAreaIns",
        params: {
            rnhAreaCod: data?.cod,
            rnhAreaNombre: data?.nombre,
            rnhZonaId: data?.zonaId,
            rnhAreaWKT: data?.wkt,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
